import { FC, useEffect, useState, useRef } from 'react';
import AliyunUploadImages from './aliyunUploadImages';
import MinioUploadImages from './minioUploadImages';
import { oss_file_getPostPolicy_api } from '../../api/oss/file';
import {
  OSSDataConfig,
  AliyunUploadImagesProps,
  MinioUploadImagesProps,
  EXPIRE_TIME,
  EXPIRE_EFFECTIVE_TIME,
} from '../interface';
import { SUCCESS_STATUS_CODE } from '../../constants/constant';

export type UploadImagesProps =
  | AliyunUploadImagesProps
  | MinioUploadImagesProps;

const UploadImages: FC<UploadImagesProps> = props => {
  const { scene } = props;
  const [OSSData, setOSSData] = useState<OSSDataConfig>();
  const timer = useRef<any>();
  useEffect(() => {
    init();
  }, []);
  /** 初始化数据 */
  const init = async () => {
    if (!scene) return;
    const CACHE_SCENE = window.sessionStorage.getItem(scene);
    if (!CACHE_SCENE) {
      window.sessionStorage.setItem(scene, 'loading');
      const res = await oss_file_getPostPolicy_api(scene);
      if (res.code === SUCCESS_STATUS_CODE) {
        const data = res.data;
        const {
          host,
          endpoint,
          policy,
          accessid,
          signature,
          dir,
          effectiveDuration = EXPIRE_EFFECTIVE_TIME,
          type,
          allowList,
          expire,
        } = data;
        const effectiveTime = Date.now() + effectiveDuration;
        const newOSSData = {
          host,
          endpoint,
          policy,
          accessid,
          signature,
          dir,
          effectiveTime,
          expire: expire || effectiveTime,
          type,
          accept: Array.isArray(allowList)
            ? allowList.map(v => `.${v}`).join(',')
            : undefined,
        };
        window.sessionStorage.setItem(scene, JSON.stringify(newOSSData));
        setOSSData(newOSSData);
      }
    }
    if (CACHE_SCENE === 'loading') {
      timer.current = setInterval(() => {
        const resData = window.sessionStorage.getItem(scene);
        if (resData && resData !== 'loading') {
          clearInterval(timer.current);
          setOSSData(JSON.parse(resData));
        }
        if (!resData) clearInterval(timer.current);
      }, 50);
      return;
    }
    if (CACHE_SCENE) {
      const oldOSSData = JSON.parse(CACHE_SCENE);
      const { expire } = oldOSSData;
      const expireTime = Number(expire) * 1000;
      const nowTime = Date.now() + EXPIRE_TIME;
      if (expireTime < nowTime) {
        window.sessionStorage.setItem(scene, '');
        init();
        return;
      }
      setOSSData(oldOSSData);
    }
  };
  return (
    <>
      {OSSData?.type === 'aliyun' && (
        <AliyunUploadImages
          OSSData={OSSData}
          onReset={init}
          accept={OSSData.accept}
          scene={scene}
          {...props}
        />
      )}
      {OSSData?.type === 'minio' && (
        <MinioUploadImages
          uploadUrl={OSSData.host}
          onReset={init}
          accept={OSSData.accept}
          {...props}
        />
      )}
    </>
  );
};

export default UploadImages;
